<template>
  <div>
    <mdbRow class="mt-3">
      <mdbCol class="d-flex justify-content-center">
        <mdb-icon class="cs-grey-text" size="2x" icon="star" />
      </mdbCol>
      <mdbCol class="d-flex justify-content-center">
        <mdb-icon class="cs-grey-text" size="2x" icon="map-marker-alt" />
      </mdbCol>
      <mdbCol class="d-flex justify-content-center">
        <mdb-icon class="cs-grey-text" size="2x" icon="share-alt" />
      </mdbCol>
    </mdbRow>
    <mdbRow class="mt-3">
      <mdbCol><p v-html="getDescription()"></p></mdbCol>
    </mdbRow>
    <mdbRow class="mt-3">
      <mdbCol
        class="d-flex justify-content-center cs-pink-text font-weight-bold"
        >{{ web }}</mdbCol
      >
    </mdbRow>
  </div>
</template>

<script>
import { mdbRow, mdbCol, mdbIcon } from "mdbvue";

export default {
  name: "CouponPreviewFooter",
  components: { mdbRow, mdbCol, mdbIcon },
  props: {
    web: String,
    description: String
  },
  data() {
    return {};
  },
  methods: {
    getDescription() {
      return this.description.split("METATAGS:")[0];
    }
  },
  mounted() {}
};
</script>

<style scoped>
p {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}
</style>
